import { RefObject, useEffect } from 'react';

import { useEvent } from './useEvent.js';

export function useOutsideDetect(
  ref: RefObject<HTMLElement | null>,
  isOpen: boolean,
  onClickOutside: () => void,
) {
  const handleClickOutside = useEvent((event: MouseEvent) => {
    if (
      event.target &&
      ref.current &&
      // @ts-ignore
      !ref.current.contains(event.target)
    ) {
      onClickOutside();
    }
  });
  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () =>
        document.removeEventListener('mousedown', handleClickOutside);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, ref.current]);
}
